import { createI18n } from 'vue-i18n';

const loadedLocales = {};

function loadLocaleMessages() {
  const locales = require.context('../locales', true, /[A-Za-z0-9-_,\s]+\.js$/i);
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      loadedLocales[locale] = locales(key).default;
      console.log(locale,'ddddssdssdsdssdsdsd')
    }
  });
  return loadedLocales;
}



const i18n = createI18n({
  locale: 'CA-en',
  fallbackLocale: 'CA-en',
  messages: loadLocaleMessages(),
});

export default i18n;